(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-promo-banner"] && !Shopify.designMode) return;
  try {
    
  // promo banner — pinned text heights
  (function () {
    if (window.ygPromoStick) return;
    window.ygPromoStick = true;

    var ROOT = '[data-yg-promo-text]';
    var PARTS = [
      ['.yg-promo-banner__heading', '--yg-pb-hh'],
      ['.yg-promo-banner__sub', '--yg-pb-sh'],
      ['.yg-promo-banner__inner', '--yg-pb-ch'],
    ];
    var instances = Object.create(null);

    function attach(root) {
      var els = PARTS.map(function (part) {
        return root.querySelector(part[0]);
      });
      var sizes = els.map(function () {
        return -1;
      });

      var ro = new ResizeObserver(function (entries) {
        var changed = false;
        entries.forEach(function (entry) {
          var i = els.indexOf(entry.target);
          var box = entry.borderBoxSize && entry.borderBoxSize[0];
          var h = box ? box.blockSize : entry.target.getBoundingClientRect().height;
          if (i < 0 || h === sizes[i]) return;
          sizes[i] = h;
          root.style.setProperty(PARTS[i][1], h + 'px');
          changed = true;
        });
        if (changed && !root.hasAttribute('data-yg-pb-stick')) root.setAttribute('data-yg-pb-stick', '');
      });

      els.forEach(function (el) {
        if (el) ro.observe(el);
      });

      return {
        destroy: function () {
          ro.disconnect();
        },
      };
    }

    function init() {
      var roots = document.querySelectorAll(ROOT);
      for (var i = 0; i < roots.length; i++) {
        var id = roots[i].dataset.sectionId;
        if (!id || instances[id]) continue;
        instances[id] = attach(roots[i]);
      }
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id || !instances[id]) return;
      instances[id].destroy();
      delete instances[id];
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
